import { Injectable } from '@angular/core';
import { QuestionData } from '@core/models';

@Injectable({ providedIn: 'root' })
export class RoundUtilityService {
  constructor() {}

  /**
   * checks if every question has the same question type id as in the round filter question type dropdown
   * @param questionTypeId number
   * @param selectedQuestions QuestionData[]
   * @returns
   */
  public _categorizeQuestionTypes(
    questionTypeId: number,
    selectedQuestions: QuestionData[]
  ): boolean {
    return selectedQuestions.every(
      (question) => question.question_type_id === questionTypeId
    );
  }
}
